// extracted by mini-css-extract-plugin
export default {"container":"Header__container-SoFB","title":"Header__title-ndHp","description":"Header__description-gd3e"};